import * as React from 'react';
import { GenericNavLink } from '../generic-nav-link';
import { ContactMethodType } from '@wix/answers-api';
import { getContactOptions } from '../../../../common/contact-utils';

export const contactUrl = (contactOption) =>
  contactOption?.contactMethod?.type
    ? contactOption.contactMethod.type === ContactMethodType.EXTERNAL
      ? contactOption.contactMethod.externalUrl
      : contactOption.contactMethod.type === ContactMethodType.EMAIL
      ? `mailto:${contactOption.contactMethod.email}`
      : '/contact'
    : '/';

export const ContactLink = ({ model, biLogger }) => (props) => {
  const { children, className, component } = props;
  const { tenant } = model;
  const onClick = () => {
    return biLogger.publicClickContactUsFooter({
      location_identifier: component,
      source_type: 'customer_portal',
      source_name: 'customer_portal',
      answers_brand_id: model.tenant.brandId,
    });
  };
  const contactOption = getContactOptions(tenant);
  return (
    <GenericNavLink
      className={className}
      uri={contactUrl(contactOption)}
      onClick={onClick}
    >
      {children}
    </GenericNavLink>
  );
};
